import { types } from 'mobx-state-tree';

import moment from 'moment-timezone';

import DateTime from '@utils/mst/types/DateTime';
import BenefitTag from './BenefitTag';

const BenefitService = types
  .model('BenefitService', {
    id: types.identifierNumber,
    name: types.string,
    description: types.maybeNull(types.string),
    eligibilityInfo: types.maybeNull(types.string),
    hoursOfOperation: types.maybeNull(types.string),
    instructions: types.maybeNull(types.string),
    whatToExpect: types.maybeNull(types.string),
    registrationInstructions: types.maybeNull(types.string),
    criteria: types.maybeNull(types.union(types.string, types.frozen())),
    createdAt: DateTime,
    updatedAt: types.maybeNull(DateTime),
    deletedAt: types.maybeNull(DateTime),
    vendorId: types.number,
    activeFrom: types.maybeNull(DateTime),
    activeTo: types.maybeNull(DateTime),
    tags: types.maybeNull(types.array(BenefitTag)),
    excludedFromOrgs: types.maybeNull(types.array(types.number)),
  })
  .views((self) => ({
    get createdAtMoment(): string {
      return moment(self.createdAt).format('DD MMMM YYYY hh:mm A');
    },
    get activeFromMoment(): string {
      return self.activeFrom ? moment(self.activeFrom).format('YYYY-MM-DDTHH:mm') : '';
    },
    get activeToMoment(): string {
      return self.activeTo ? moment(self.activeTo).format('YYYY-MM-DDTHH:mm') : '';
    },
  }));

export default BenefitService;
